<template>
  <div class="main-body">
    <div class="header">
      房间类型
    </div>
    <div class="out">

      <div class="search2">


          <el-button size="mini" type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
          <el-button size="mini" type="danger" :disabled="disabledEdit" @click.native="handleEdit">编辑</el-button>
          <div style="float:right">
            <el-input  placeholder="请输入类型名称" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
            <el-select v-model="status" placeholder="选择房间类型状态" style="margin:0 10px;" clearable>
              <el-option
                  v-for="item in statusValue"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val">
              </el-option>
            </el-select>
            <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
          </div>


        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="price" label="价格(元/天)" v-if="dayShow"></el-table-column>
        <el-table-column prop="priceMonth" label="价格(元/月)" v-if="monthShow"></el-table-column>

        <el-table-column prop="num" :formatter="roomTypeTitle" label="几人间"></el-table-column>
        <el-table-column
            prop="Status"
            :formatter="statusTitle"
            label="状态">
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd"  v-bind:buildingCodeValue="buildingCodeValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:buildingCodeValue="buildingCodeValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import {getStaffCode,getChargeTime} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{
      loading:false,
      dayShow:false,
      monthShow:false,

      showModalAdd:false,
      showModalEdit:false,
      disabledAdd:false,
      menuButtonList:null,
      disabledEdit:true,

      tableData:null,
      status:-1,
      roomType:'',
      buildingCode:'',
      name:'',
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,
      selectInfo:'',
      buildingCodeValue:[],
      statusValue:[{
        val:-1,
        name:'全部状态'
      },{
        val:0,
        name:'正常'
      },{
        val:1,
        name:'禁用'
      }],
    }
  },
  components:{
    Add,Edit
  },
  created(){
    if(getChargeTime()=="天"){
      this.dayShow=true;
    }else{
      this.monthShow = true;
    }
    this.getList();
    this.init();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    init:function(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Building/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.buildingCodeValue = response.data.data;
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },
    handleChange(value) {
      this.roomCode=value[1];
      console.log(this.roomCode);
    },
    handleEdit() {
      this.$refs.myEdit.init(this.selectInfo);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"RoomType/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name:this.name,
          status:this.status,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        console.log(response);
        this.disabledEdit=true;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    statusTitle(row){
      const statusValue=this.statusValue
      for(var i in statusValue){
        if(statusValue[i].val==row.status){
          return statusValue[i].name
        }
      }
    },
    roomTypeTitle(row){
      return row.num+' 人间'
    },
    rowClick(row){
      this.selectInfo=row
      //if(this.menuButtonList.indexOf("编辑")!=-1){
        this.disabledEdit =false;
      //}
    }


  }
}
</script>

<style lang="scss" scoped>
.rooomType /deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
